module.exports = __webpack_public_path__ + "static/HowDoWeDoIt-545a019b1b64e685d4f4102bc88f1504.png";